import NotFound from "@/components/AppRouter/NotFound";
import { useUserSettings } from "@/hooks/useUserSettings";
import { Outlet } from "react-router-dom";

export default function Admin() {
  const { data: userSettings } = useUserSettings();

  if (userSettings && userSettings.role !== "root_admin") {
    return <NotFound />;
  }

  return <Outlet />;
}
